import { A, Z } from '@angular/cdk/keycodes';
import { Directive, ElementRef, forwardRef, HostListener, Input, Renderer2, Self } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';

@Directive({
    selector: '[upperCase]',
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => UpperCaseDirective),
            multi: true,
        },
    ],
})
export class UpperCaseDirective implements ControlValueAccessor {

    @Input() upperCase = false;
    _onChange: (_: any) => void;
    _touched: () => void;

    constructor(@Self() private _el: ElementRef, private _renderer: Renderer2) {
    }

    @HostListener('keyup', ['$event'])
    onKeyDown(evt: KeyboardEvent) {
        const keyCode = evt.keyCode;
        const key = evt.key;
        evt.preventDefault();
        const value = this._el.nativeElement.value.toUpperCase();
        if (keyCode >= A && keyCode <= Z && this.upperCase) {
            this._renderer.setProperty(this._el.nativeElement, 'value', value);
            this._onChange(value);
        } else {
            this._onChange(value);
        }
    }

    @HostListener('blur', ['$event'])
    onBlur() {
        this._touched();
    }

    writeValue(value: any): void {
        this._renderer.setProperty(this._el.nativeElement, 'value', value);
    }

    registerOnChange(fn: (_: any) => void): void {
        this._onChange = fn;
    }

    registerOnTouched(fn: () => void): void {
        this._touched = fn;
    }

    setDisabledState(isDisabled: boolean): void {
        this._renderer.setProperty(this._el.nativeElement, 'disabled', isDisabled);
    }
}
